import React, { useEffect } from 'react';
import FormSender from '../components/orderPage/formSender/FormSender';
import { useParams } from 'react-router';

const CONFIG = {
	hr: {
		title: 'Kako funkcionira Razgoto tečaj',
		description: 'Zanima te tečaj? Želiš više informacija?',
	},

};

const OrderPage = ({ data }) => {
	const { lang } = useParams();

	useEffect(() => {
		document.title = CONFIG[lang]?.title;
		document.getElementsByName('description')[0].content =
			CONFIG[lang]?.description;
	}, [lang]);

	return (
		<div>
			<FormSender data={data.formControll} />
		</div>
	);
};

export default OrderPage;
